export const MESSAGES = {
  NO_DATA_FOUND: 'No data found.',
};
